import React from 'react';

export default class  Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Show them you care</div>
                                            <p>Make time for and express personal interest in individuals –
                                                without seeming intrusive – even if just a friendly enquiry
                                                about their weekend. Ask for opinions about work, working
                                                methods and general morale to demonstrate that you value their
                                                views.</p>

                                            <div className="border_subtitle">Make yourself available</div>
                                            <p>Make yourself available and visible so that people regard you as
                                                part of the team and willing to help. It will reassure them and
                                                may give you additional insight about their daily concerns, or
                                                enable you to make more appropriate decisions concerning the
                                                whole team.</p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">ENERGISING OTHERS – ENERGISER OF THE WEEK</span>
                                            </div>
                                            <div className="border_subtitle">Energiser of the week!<a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>9</sup></a></div>
                                            <p>The purpose of this exercise is to boost the team’s energy and
                                                productivity with a new strategy and incentive, each week.
                                                Making your team responsible for choosing its own weekly
                                                incentive will help gain commitment and encourage a feeling of
                                                self determination and motivation. This is a great way to build
                                                the all-important ‘team spirit’, too!</p>
                                            <p>It also allows people to contribute different ideas each week –
                                                and the variety will stimulate interest, imagination and – most
                                                important – fun! If possible, provide a small budget, of say
                                                £10-£20 for an energising activity for the workforce.</p>
                                            <div className="border_subtitle">What to do</div>
                                            <p>Give the ‘energiser’ as much freedom as possible and make sure
                                                they clearly define the result they expect from their idea. They
                                                may wish to reduce stress in the team, improve communication or
                                                achieve particular targets, and incentives might include a
                                                lunchtime video or picnic, changing the office decor in some way
                                                as well as the ubiquitous bottles of wine or boxes of
                                                chocolates.</p>
                                            <p>The ‘energiser of the week’ will need to consider team members’
                                                interests and motivations when choosing strategies. For example,
                                                if the company in question was a video production company, and
                                                the team consisted of keen actors, then on a good weather day,
                                                the team could go outside and act out some of the videos they’d
                                                been working on.</p>
                                            <div className="border_subtitle">Then…</div>
                                            <p>When every team member has had the opportunity to be ‘energiser
                                                of the week’ get everyone to choose which idea they found most
                                                motivating or which worked best by voting 1-3 for each idea– and
                                                the winner gets to plan a bigger-scale energiser.</p>

                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page4')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page6')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}